angular.module('zc')
  .component('zcIwMainComparison', {
    templateUrl: '/templates/projects.iw/iw_main_comparison.html',
    bindings: {
      project: '<',
      filters: '<'
    },
    controller: zcIwMainComparisonController
  });

zcIwMainComparisonController.$inject = ['$scope', '$translate', 'InterestWidgetStats', 'SearchFilter', 'ChartV2', 'lineChartV2Config', 'iwGraphOptions', 'currencies', 'lib'];
function zcIwMainComparisonController($scope, $translate, InterestWidgetStats, SearchFilter, ChartV2, lineChartV2Config, iwGraphOptions, currencies, lib) {
  const vm = this;

  vm.currency = currencies[vm.project.currency];
  vm.iwGraphOptions = iwGraphOptions;
  vm.updateData = updateData;

  const chart = new ChartV2(lineChartV2Config);
  vm.chartConfig = chart.getConfig();

  vm.$onInit = () => {
    updateData();
    $scope.$on('filtersUpdated', updateData);
    $scope.$on('filtersReset', reset);
    $scope.$on('destroy', destroy);
  };

  SearchFilter.setComponentDefaults('zcIwReport', {
    iw_graph_option: {
      default: vm.iwGraphOptions[0].name,
      keyProperty: 'name',
      getter: function(name) {
        return _.find(vm.iwGraphOptions, function(opt) {
          return opt.name === name;
        });
      }
    }
  });

  function updateData() {
    SearchFilter.updateComponentDefaults('zcIwReport');
    InterestWidgetStats.findByFilters(vm.project.apikey, vm.filters)
      .then(stats => {
        vm.total = InterestWidgetStats.transform(lib.sumCountMap(stats));
        const iwUseData = [];
        const noIwUseData = [];
        stats.forEach(stat => {
          stat = InterestWidgetStats.transform(stat);
          iwUseData.push([stat.start_at.valueOf(), stat.iw_use[vm.filters.iw_graph_option_value.name]]);
          noIwUseData.push([stat.start_at.valueOf(), stat.no_iw_use[vm.filters.iw_graph_option_value.name]]);
        });
        const tooltip = getTooltip();
        chart.resetSeries();
        chart.addSeries({ name: $translate.instant('projectsIw.mainComparison.iwUseData'), data: iwUseData, tooltip: tooltip });
        chart.addSeries({ name: $translate.instant('projectsIw.mainComparison.noIwUseData'), data: noIwUseData, tooltip: tooltip });
      });
  }

  function getTooltip() {
    if(vm.filters.iw_graph_option_value.name === 'average_conversion_price') {
      return {
        valueSuffix: vm.currency.suffix,
        valueDecimals: vm.currency.fractionSize
      };
    }
    return {
      valueSuffix: vm.filters.iw_graph_option_value.unit,
      valueDecimals: vm.filters.iw_graph_option_value.decimal
    };
  }

  function reset() {
    SearchFilter.resetComponentDefaults('zcIwReport');
  }

  function destroy() {
    SearchFilter.removeComponentDefaults('zcIwReport');
  }
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.iw/iw_main_comparison.js